// @core/api/endpoints/localization/get_namespace.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  NamespaceResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Get translation namespace
 * Retrieves a translation namespace by ID or slug.
 */
export async function GetNamespace(
  namespace_id: string,
  options?: RequestOptions
): Promise<NamespaceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/localization/namespaces/:namespace_id`;
  requestPath = requestPath.replace(':namespace_id', encodeURIComponent(namespace_id));
  const requestOptions = options;
  return client.get<NamespaceResponse>(requestPath, { ...requestOptions });
}
